import { useState } from "react";
import { Outlet } from "react-router-dom";
import MobileMenu from "../../sections/mobileMenu/mobileMenu";
import Header from "../../sections/header/header";
import Footer from "../../sections/footer/footer";
import PopupForm from "../../sections/popupForm/popupForm";
import CallbackForm from "../../sections/callbackForm/callbackForm";
import ChatProvider from "../../providers/ChatProvider";
import { conversations } from "../../data/chat";
import ChatWidget from "../../components/common/chat-widget/ChatWidget";

const Chat = () => {
  const [message, setMessage] = useState("");

  return (
    <>
      <MobileMenu />
      <div className="page page--index page--cabinet">
        <Header />
        <ChatProvider conversations={conversations}>
          <main className="page__main">
            <div className="chat page-container d-flex gap-3 pt-6">
              <Outlet />
            </div>
          </main>
        </ChatProvider>
        <Footer />
        <ChatWidget />
        <PopupForm setMessage={setMessage} />
        <CallbackForm />
      </div>
    </>
  );
};

export default Chat;
